import React from "react";
import {Button, Col, Form, Icon, Input, notification, Row,} from "antd";
import {Link, Redirect} from "react-router-dom";

import {AppContext} from "../../../contexts/app-context";
import {userServices} from "../../../services";
import i18n from "../../../i18n";

import Spinner from "../../spinner";
import Banner from "../../banner";

class LoginPage extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            username: this.resetData(),
        };

        this.buttonStyle = {
            width: "100%",
            fontSize: "20px",
            height: "40px",
            backgroundColor: "#1CAA53",
            borderRadius: "7px",
        };
    }

    onSubmitFormLogin = (event) => {
        event.preventDefault();

        this.props.form.validateFields((error, values) => {
            if (error) {
                return;
            }

            this.setState({
                loading: true,
            });

            this.context
                .login(values.login, values.password)
                .catch((error) => {
                    const errorMessage =
                        typeof error === "string"
                            ? error
                            : error && error.message
                                ? error.message
                                : i18n.t(
                                    "loginPage.notification.login.error"
                                );

                    notification.warning({
                        message: i18n.t("loginPage.notification.login.title"),
                        description: errorMessage,
                    });

                    this.setState({
                        loading: false,
                    });
                });
        });
    };

    resetData = () => {
        let username = "";

        if (
            this.props.location.state &&
            this.props.location.state.reset
        ) {
            username = this.props.location.state.reset.username;

            notification.success({
                message: i18n.t("loginPage.notification.reset.title"),
                description: `${i18n.t(
                    "loginPage.notification.reset.success.message"
                )} ${username}`,
                duration: 20,
            });
        }

        return username;
    };

    render() {
        this.user = userServices.getUser();

        if (this.user.loggedIn) {
            return <Redirect to="/"/>;
        }

        if (this.context.filter.enable) {
            this.context.disableFilter();
        }

        const {getFieldDecorator} = this.props.form;

        return (
            <Spinner
                loading={this.state.loading}
                label={i18n.t("main.loadText.loading")}
            >
                <div className="container">
                    <Row>
                        <Col
                            span={12}
                            offset={6}
                            className="login-page-content"
                        >
                            <h1>{i18n.t("loginPage.titles.main")}</h1>

                            <Form
                                onSubmit={this.onSubmitFormLogin}
                                className="login-form"
                            >
                                <Form.Item>
                                    {getFieldDecorator("login", {
                                        rules: [
                                            {
                                                required: true,
                                                message: i18n.t(
                                                    "loginPage.form.login.error"
                                                ),
                                            },
                                        ],
                                        initialValue: this.state.username,
                                    })(
                                        <Input
                                            size="large"
                                            prefix={
                                                <Icon
                                                    type="user"
                                                    style={{color: "rgba(0,0,0,.25)"}}
                                                />
                                            }
                                            placeholder={i18n.t(
                                                "loginPage.form.login.placeholder"
                                            )}
                                        />
                                    )}
                                </Form.Item>

                                <Form.Item>
                                    {getFieldDecorator("password", {
                                        rules: [
                                            {
                                                required: true,
                                                message: i18n.t(
                                                    "loginPage.form.password.error"
                                                ),
                                            },
                                        ],
                                    })(
                                        <Input.Password
                                            size="large"
                                            prefix={
                                                <Icon
                                                    type="lock"
                                                    style={{color: "rgba(0,0,0,.25)"}}
                                                />
                                            }
                                            placeholder={i18n.t(
                                                "loginPage.form.password.placeholder"
                                            )}
                                        />
                                    )}
                                </Form.Item>

                                <Form.Item>
                                    <Button
                                        type="primary"
                                        style={this.buttonStyle}
                                        htmlType="submit"
                                        className="login-form-button"
                                    >
                                        {i18n.t("loginPage.form.buttons.submit")}
                                    </Button>
                                </Form.Item>
                            </Form>

                            <Row
                                type="flex"
                                justify="space-between"
                                style={{
                                    maxWidth: "700px",
                                    margin: "0 auto",
                                }}
                            >
                                <Link to="/reset" className="link-login">
                                    {i18n.t("loginPage.links.reset")}
                                </Link>

                                <Link to="/register" className="link-register">
                                    {i18n.t("loginPage.links.register")}
                                </Link>
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} lg={12}>
                            <Banner banner={1}/>
                        </Col>

                        <Col xs={24} lg={12}>
                            <Banner banner={2}/>
                        </Col>
                    </Row>
                </div>
            </Spinner>
        );
    }
}

export default Form.create({
    name: "normal_login",
})(LoginPage);
